function handleAnnouncementTest() {
      const originalBar = document.querySelector('.annc-original');
      const secondBar = document.querySelector('.annc-second');
      
      const variant = localStorage.getItem('announcement_variant');
      console.log('Running test for variant:', variant);
      
      if (variant === 'test') {
        // Test variant: Show second, hide original
        secondBar.style.cssText = 'display: block !important; visibility: visible !important';
        originalBar.style.cssText = 'display: none !important';
      } else {
        // Control variant: Show original, hide second
        originalBar.style.cssText = 'display: block !important';
        secondBar.style.cssText = 'display: none !important';
      }
    }

document.addEventListener('DOMContentLoaded', function() {
        handleAnnouncementTest();
});

// Images in menu
// Check if user has been assigned to test group
// Get the mobile menu element
const mobileMenu = document.querySelector('.mobile-menu__three-column');

// Show menu if user is in test group
if (localStorage.getItem('mobile_menu_test') === 'menu-true' && mobileMenu) {
  mobileMenu.style.visibility = 'visible';
  mobileMenu.style.opacity = '1';
} else if (mobileMenu) {
  mobileMenu.style.visibility = 'hidden';
  mobileMenu.style.opacity = '0';
}

//Quick Links
// Set up localStorage check for quicklnk test
function initQuickLinksTest() {
  const isMobile = window.innerWidth < 768;
  const quickLinksDiv = document.querySelector('.quicklnk');
  
  if (!isMobile || !quickLinksDiv) return;

  const testVariant = localStorage.getItem('quicklinks_test');
    
  if (localStorage.getItem('quicklinks_test') === 'control') {
    quickLinksDiv.style.display = 'none';
  } else {
    quickLinksDiv.style.display = 'block';
  }
}

